export default __webpack_public_path__ + "static/content-4dae73b8b306dbd08f0baf396ab4a3e8.jpg";